import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ViewChild,
  OnChanges,
  SimpleChanges,
  output,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import {
  MatPaginator,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import {
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { provideNativeDateAdapter } from '@angular/material/core';
import {
  UserTableRow,
  UserTableAction,
  UserTableConfig,
} from './users-table.types';

@Component({
  selector: 'app-users-table',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatChipsModule,
    MatIconModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
  ],
  templateUrl: './users-table.component.html',
  styleUrls: ['./users-table.component.scss'],
  providers: [provideNativeDateAdapter()],
  encapsulation: ViewEncapsulation.None,
})
export class UsersTableComponent implements AfterViewInit, OnChanges {
  dataSource = input(new MatTableDataSource<UserTableRow>([]));
  isLoading = input(false);
  length = input(0);
  config = input<UserTableConfig>({
    columns: [
      'name',
      'email',
      'role',
      'organizationName',
      'lastAccess',
      'status',
    ],
    showActionsColumn: true,
  });
  actions = input<UserTableAction[]>([]);

  sortChange = output<Sort>();
  pageChange = output<PageEvent>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatTable) table!: MatTable<UserTableRow>;

  displayedColumns: string[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['config']) {
      this.updateDisplayedColumns();
    }

    if (changes['dataSource'] && this.table) {
      this.table.renderRows();
    }
  }

  ngAfterViewInit(): void {
    const dataSource = this.dataSource();
    dataSource.sort = this.sort;

    if (this.config().columns && this.sort) {
      const initialSort = this.config().columns[0];
      if (initialSort) {
        this.sort.active = initialSort;
        this.sort.direction = 'desc';
      }
    }
  }

  private updateDisplayedColumns(): void {
    this.displayedColumns = [...this.config().columns];

    if (this.config().showActionsColumn) {
      this.displayedColumns.push('actions');
    }
  }

  onSortChange(sort: Sort): void {
    this.sortChange.emit(sort);
  }

  onPageChange(event: PageEvent): void {
    this.pageChange.emit(event);
  }

  getStatusLabel(status: UserTableRow['status']): string {
    return status === 'active' ? 'Ativo' : 'Inativo';
  }

  getStatusClass(status: UserTableRow['status']): string {
    return status === 'active' ? 'status-active' : 'status-inactive';
  }

  getRoleClass(role: string): string {
    return 'role-' + role.toLowerCase().replace(/[^a-z0-9]+/g, '-');
  }

  shouldShowAction(action: UserTableAction, user: UserTableRow): boolean {
    return action.condition ? action.condition(user) : true;
  }
}
